/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbTypeEnseignementDto } from './FcbTypeEnseignementDto';
import {
    FcbTypeEnseignementDtoFromJSON,
    FcbTypeEnseignementDtoFromJSONTyped,
    FcbTypeEnseignementDtoToJSON,
} from './FcbTypeEnseignementDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbTypeEnseignementDtoPaginatedResults
 */
export interface FcbTypeEnseignementDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbTypeEnseignementDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbTypeEnseignementDto>}
     * @memberof FcbTypeEnseignementDtoPaginatedResults
     */
    results?: Array<FcbTypeEnseignementDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbTypeEnseignementDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbTypeEnseignementDtoPaginatedResults interface.
 */
export function instanceOfFcbTypeEnseignementDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeEnseignementDtoPaginatedResultsFromJSON(json: any): FcbTypeEnseignementDtoPaginatedResults {
    return FcbTypeEnseignementDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbTypeEnseignementDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeEnseignementDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbTypeEnseignementDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbTypeEnseignementDtoPaginatedResultsToJSON(value?: FcbTypeEnseignementDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbTypeEnseignementDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

